import { Injectable } from '@angular/core';
import { KioskService } from './kiosk.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NavigationService } from '@app/shared/services/navigation.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { BreakReminderService } from './break-reminder.service';

@Injectable({
  providedIn: 'root',
})
export class KickOutTimerService {
  timeoutIntervalRef: any;
  constructor(
    private kioskService: KioskService,
    private navigationService: NavigationService,
    private dialogRef: MatDialog,
    private breakReminderService: BreakReminderService
  ) {}

  initTimeout() {
    this.timeoutIntervalRef = setTimeout(() => {
      this.kickOut();
    }, 20 * 1000);
  }

  restartTimeout() {
    this.flushTimeout();
    this.initTimeout();
  }

  flushTimeout() {
    clearTimeout(this.timeoutIntervalRef);
  }

  kickOut() {
    const breakReminderActive =
      this.breakReminderService.breakReminderInfo$.getValue()?.openReminder;

    if (breakReminderActive) {
      this.breakReminderService.clearBreakReminder();
      this.kioskService.handleAutoDeductBreak(
        this.kioskService.lastAttendanceEntry$.getValue(),
        this.kioskService.pincodeUser$.getValue()?.userPolicy,
        this.kioskService.lastAttendanceEntry$.getValue(),
        this.kioskService.pincodeUser$.getValue()?.userProfile
      );
    }
    this.flushTimeout();
    this.dialogRef.closeAll();
    this.kioskService.flushPincodeUser();
    this.navigationService.goToPinCode();
  }
}
